import React from 'react';
import { Button, Form } from 'react-bootstrap';
export default function Signup() {
  return (
    <div  className='signup-page'>
         <Form.Control type="email" placeholder="name@example.com" />
         <Form.Control type="tel" placeholder="Mobile Number" />
        <Form.Control type="password" placeholder="Password" />
        <Button>Signup</Button>
    </div>
  )
}
